export default __webpack_public_path__ + "static/media/2728 utensils side.cda9dd2d.png";